import React from 'react';
import { utils, viewModeWrapper } from 'pro-gallery-lib';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ViewModeWrapperHOC = (WrappedComponent) => {
    return class ViewModeWrapperHOC extends React.Component {
        constructor(props) {
            super(props);
            this.initViewModeWrapper(props);
        }
        initViewModeWrapper(props) {
            if (typeof props.viewMode !== 'undefined') {
                viewModeWrapper.setViewMode(props.viewMode);
            }
            if (typeof props.deviceType !== 'undefined' && viewModeWrapper._deviceType !== props.deviceType) {
                utils.dumpCache();
                viewModeWrapper.setDeviceType(props.deviceType);
            }
        }
        updateViewModeWrapper(nextProps) {
            if (this.props.viewMode !== nextProps.viewMode) {
                utils.dumpCache();
                viewModeWrapper.setViewMode(nextProps.viewMode);
            }
            if (this.props.deviceType !== nextProps.deviceType) {
                utils.dumpCache();
                viewModeWrapper.setDeviceType(nextProps.deviceType);
            }
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            this.updateViewModeWrapper(nextProps);
        }
        render() {
            return React.createElement(WrappedComponent, Object.assign({}, this.props));
        }
    };
};
//# sourceMappingURL=viewModeWrapper.js.map